import React from 'react';
import IntroSection from '../components/IntroSection';
import IndustryDetailsSection from '../components/IndustryDetailsSection';
import BlueSectionDivider from '../components/BlueSectionDivider';
import CountriesSection from '../components/CountriesSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const AllIndustries = () =>{
    return (
        <div>
            <IntroSection title="PROVIDING CUSTOM SOLUTIONS TO YOUR INDUSTRY" paragraph="We foster innovation across many industries, from healthcare, finance,and travel to real estate." backgroundImage="/images/industries-bg.webp"/>
            <IndustryDetailsSection/>
            <BlueSectionDivider/>
            <CountriesSection/>
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>

        </div>
    )
}
export default AllIndustries;